import { Grid } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { useSearchParameters } from 'hooks/useSearchParameters';
import { queryParams } from 'utils/query';
import { DebouncedInput } from 'components/ControlledInputs/DebouncedInput';
import { TableConfig } from 'models/general';
import { InfoIcon } from 'components/InfoIcon';

interface Props {
  config: TableConfig;
}

export const SettingsListFilters = ({ config }: Props) => {
  const { queryKey } = config;
  const { t } = useTranslation();
  const { parameters: filters, setParameters } = useSearchParameters(queryKey);

  const handleFilterChange = (filterKey: string, input: string) => {
    setParameters({ ...filters, [filterKey]: input });
  };

  return (
    <Grid px={'xs'} pt={'xs'} pb={'md'} align={'center'}>
      <Grid.Col span={2}>
        <DebouncedInput
          searchOption
          onChange={(value) => handleFilterChange(queryParams.name, value)}
          value={filters[queryParams.name]}
          placeholder={t('search_by_group')}
          testId={'group-name'}
        />
      </Grid.Col>
      <Grid.Col offset={9.75} span={0.25} ta={'right'}>
        <InfoIcon i18nKey={'text_disclaimer_patients_list'} />
      </Grid.Col>
    </Grid>
  );
};
